module.exports = __webpack_public_path__ + "img/tieq2.794068e8.jpg";